// src/components/common/NotificationInitializer.js
import { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { initializeNotifications } from '../../utils/initializeNotifications';

function NotificationInitializer() {
  const { isAuthenticated } = useAuth();
  const [notificationSystem, setNotificationSystem] = useState(null);

  // Inicializar y limpiar sistema de notificaciones
// En NotificationInitializer.js
useEffect(() => {
    if (isAuthenticated) {
      console.log('✅ Inicializando sistema de notificaciones - Usuario autenticado');
      const system = initializeNotifications();
      setNotificationSystem(system);
      
      // Limpiar al desmontar
      return () => {
        if (system && system.cleanup) {
          console.log('🧹 Limpiando sistema de notificaciones');
          system.cleanup();
        }
      };
    } else {
      console.log('❌ Usuario no autenticado, sistema de notificaciones no inicializado');
    }
  }, [isAuthenticated]);

  // Este componente no renderiza nada visible
  return null;
}

export default NotificationInitializer;